/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { QueryBuilder } from "mst-gql"
import { PlanningActionDtoModelType } from "./PlanningActionDtoModel"
import { PlanningActionDtoModelSelector, planningActionDtoModelPrimitives } from "./PlanningActionDtoModel.base"
import { VisitDtoModelType } from "./VisitDtoModel"
import { VisitDtoModelSelector, visitDtoModelPrimitives } from "./VisitDtoModel.base"

export type UpdateProjectVisitResolverUnion = VisitDtoModelType | PlanningActionDtoModelType

export class UpdateProjectVisitResolverModelSelector extends QueryBuilder {
  visitDto(builder?: string | VisitDtoModelSelector | ((selector: VisitDtoModelSelector) => VisitDtoModelSelector)) { return this.__inlineFragment(`VisitDto`, VisitDtoModelSelector, builder) }
  planningActionDto(builder?: string | PlanningActionDtoModelSelector | ((selector: PlanningActionDtoModelSelector) => PlanningActionDtoModelSelector)) { return this.__inlineFragment(`PlanningActionDto`, PlanningActionDtoModelSelector, builder) }
}
export function selectFromUpdateProjectVisitResolver() {
  return new UpdateProjectVisitResolverModelSelector()
}

// provides all primitive fields of union member types combined together
export const updateProjectVisitResolverModelPrimitives = selectFromUpdateProjectVisitResolver().visitDto(visitDtoModelPrimitives).planningActionDto(planningActionDtoModelPrimitives)